import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import UnknownProfileImage from '../../assets/profile.jpg';
import { AuthContext } from '../../context/AuthContext';
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  CardHeader,
  Divider,
  Stack,
} from '@mui/material';
import './modal.css';
import { updateActorRating } from '../../api/axios';
import Slider from 'react-slick';

const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  boxShadow: 24,
  p: 4,
};

const ActorModal = ({
  actor,
  closeModal,
  contactActor,
  isModalOpen,
  role,
  setIsModalOpen,
}) => {
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const [open, setOpen] = React.useState(true);
  const { isAuthenticated } = useContext(AuthContext);

  const handleViewProfile = (name, id) => {
    // console.log('Viewing profile', name, role);
    navigate(`/actors/${name}/${id}/crew`);
  };

  // Safely access nested properties with fallback values
  const imageURL =
    actor?.user?.imageURL || actor?.profile?.imageURL || UnknownProfileImage;
  const imagesArray =
    actor?.user?.images &&
      Array.isArray(actor.user.images) &&
      actor.user.images.length > 0
      ? actor.user.images
      : [
        actor?.user?.imageURL ||
        actor?.profile?.imageURL ||
        UnknownProfileImage,
      ];
  const firstName = actor?.user?.firstName || 'Unknown';
  const lastName = actor?.user?.lastName || 'Actor';
  const rating = actor?.user?.rating || '';
  const age = actor?.user?.age || actor?.profile?.age || '';
  const height = actor?.profile?.height || '';
  const weight = actor?.profile?.weight || '';
  const hairColor = actor?.profile?.hairColor || '';
  const eyeColor = actor?.profile?.eyeColor || '';
  const dressSize = actor?.profile?.dressSize || '';
  const about = actor?.profile?.about || 'No information available.';
  const hobbies = actor?.profile?.hobbies || 'No information available.';
  const rate = actor?.profile?.rate || 0;

  let category = actor?.profile?.category || [];
  if (category) {
    if (typeof category === "string") {
      category = category.split(",").map(item => item.trim());
    }
  }

  return (
    // <Modal open={isModalOpen && open} onClose={closeModal}>
    //   <Box
    //     sx={{
    //       display: 'flex',
    //       width: '50%',
    //       maxWidth: '900px',
    //       bgcolor: 'background.paper',
    //       borderRadius: 3,
    //       overflow: 'hidden',
    //       mx: 'auto',
    //       mt: 5,
    //       position: 'relative',
    //     }}
    //   >
    <Modal
      open={isModalOpen && open}
      onClose={closeModal}
      BackdropProps={{
        sx: {
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          backgroundColor: "rgba(0,0,0,0.3)",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",

          display: "flex",
          width: {
            xs: "95%",
            sm: "90%",
            md: "80%",
            lg: "50%",
          },

          bgcolor: "background.paper",
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <Card sx={{ color: '#6e0506', display: 'flex', width: '100%' }}>
          {/* <CardMedia
            component="img"
            sx={{ width: "40%", height: 400 }}
            image={imageURL}
            alt={`${firstName} ${lastName}`}
          /> */}
          <Box sx={{ width: '40%', height: '400px', position: 'relative' }}>
            <Slider
              dots={true}
              infinite={true}
              speed={500}
              slidesToShow={1}
              slidesToScroll={1}
              autoplay={true}
              autoplaySpeed={3000}
              arrows={false}
              style={{
                width: '100%',
                height: '100%',
              }}
            >
              {imagesArray.map((image, index) => (
                <div
                  key={index}
                  style={{
                    width: '100%',
                    height: '400px',
                    padding: '0px',
                  }}
                >
                  <CardMedia
                    component='img'
                    image={image}
                    alt={actor.user?.firstName || 'Unknown'}
                    sx={{
                      width: '100%',
                      height: '400px',
                      objectFit: 'cover',
                    }}
                  />
                </div>
              ))}
            </Slider>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '60%' }}>
            <Box
              sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <CardHeader
                title={`${firstName.charAt(0).toUpperCase() + firstName.slice(1)
                  } ${lastName.charAt(0).toUpperCase() + lastName.slice(1)}`}
                subheader={`ID ${actor?.user?.id}`}
              />

              <IconButton
                className='actor-modal-close'
                onClick={(e) => {
                  e.stopPropagation();
                  setIsModalOpen(false);
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Divider />
            <CardContent
              sx={{
                flex: '1 0 auto',
                height: '200px',
                overflowY: 'scroll',
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
              }}
            >
              <Stack spacing={2}>
                <Typography variant='body1'>
                  <strong>Age:</strong> {age} y.o.
                </Typography>
                <Typography id="category">
                  <strong>Job Titles:</strong>{' '}
                  {category && category.length > 0
                    ? category.join(", ")
                    : "N/A"
                  }
                </Typography>


                {actor?.profile?.location && (

                  <Typography id="location">
                    <strong>Location:</strong>{' '}
                    {actor?.profile?.location ? actor?.profile?.location : "N/A"}
                  </Typography>
                )}


                <Typography variant='body1'>
                  <strong>About:</strong> <br />
                  {about}
                </Typography>
                {/* <Typography variant="body1">
                  <strong>Hobbies:</strong> <br />
                  {hobbies}
                </Typography> */}
              </Stack>
            </CardContent>

            <Divider />

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'end',
                gap: 1,
                p: 2,
              }}
            >
              {!isAuthenticated && (
                <Button
                  startIcon={<ContactPageIcon />}
                  variant='contained'
                  color='secondary'
                  onClick={contactActor}
                >
                  Contact Talent
                </Button>
              )}
              <Button
                variant='contained'
                color='primary'
                startIcon={<AssignmentIndIcon />}
                onClick={() => handleViewProfile(firstName, actor?.user?.id)}
              >
                View Full Profile
              </Button>
            </Box>
          </Box>
        </Card>
      </Box>
    </Modal>
  );
};

export default ActorModal;
